import React from 'react';

import styled from '@emotion/styled';

interface IpackageStatus {
  [props: string]: { num: number };
}

const packageStatus: IpackageStatus = {
  PENDING: { num: 0 },
  // AT_ORIGIN: { num: 0 },
  // PROCESSING_CLEARANCE: { num: 1 },
  CLEARED: { num: 1 },
  IN_WAREHOUSE: { num: 2 },
  OUT_FOR_DELIVERY: { num: 3 },
  DELIVERED: { num: 4 },
};

const statusList = [
  'Processing Clearance',
  // 'Processing Clearance',
  'Cleared',
  'At Warehouse',
  'Out For Delivery',
  'Delivered',
];

const VerticalStatusGraph = ({ status }: { status: string }) => {
  let statusPin = packageStatus[status]?.num || 0;

  return (
    <Container>
      <Ul>
        {statusList.map((status, index) => {
          let computedClassName;
          if (index <= statusPin) {
            computedClassName = 'status-dot';
          }
          if (index < statusPin) {
            computedClassName = `${computedClassName} status-line`;
          }
          return (
            <li key={index} className={computedClassName}>
              {status}
            </li>
          );
        })}
      </Ul>
    </Container>
  );
};

export default VerticalStatusGraph;

const Container = styled.div`
  display: none;
  width: 100%;
  margin-top: 6px;

  @media (max-width: 884px) {
    display: flex;
  }
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  padding-left: 0px;
  list-style-type: none;
  gap: 20px;

  & li {
    position: relative;
    top: -6px;
    color: black;
    font-weight: 600;
    font-size: 16px;
    padding-left: 20px;
  }

  & li::before {
    content: '';
    position: absolute;
    left: 0;
    z-index: 1;
    background-color: #d9d9d9;
    width: 10px;
    height: 10px;
    top: 5px;
    border-radius: 50%;
    border: 2px solid white;
  }

  & li.status-dot::before {
    background-color: #22c55e;
  }

  & li:not(:last-of-type)::after {
    content: '';
    position: absolute;
    left: 4px;
    top: calc(0% + 0px);
    z-index: 0;
    height: calc(100% + 20px);
    top: 6px;
    background-color: #d9d9d9;
    width: 2px;
  }

  & li.status-line::after {
    background-color: #22c55e;
  }
`;
